const BASE_URL = "https://api.payroom.agency/v1/";
const SOCKET_URL = "https://api.payroom.agency/";
const STORAGE_URL = "https://storage.payroom.agency/api/v1/files/";

export { BASE_URL, SOCKET_URL, STORAGE_URL };
